
import WidgetMixins from '../../../../mixins/WidgetMixins';
import Component, { mixins } from 'vue-class-component';
import { loadWidget } from '@/utils/helpers';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import { IContact, IPaginate, PayloadState } from '@/types/types';
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import { namespace } from 'vuex-class';
import { debounce } from 'lodash';

const contactModule = namespace('contact');
const groupsModule = namespace('group');
extend('required', {
  ...required,
  message: 'Field is required',
});

@Component({
  name: 'ListAllGroupContacts',
  components: {
    ValidationProvider,
    ValidationObserver,
    SkeletonPreloader: loadWidget('widgets/SkeletonPreloader'),
  },
})
export default class ListAllGroupContacts extends mixins(WidgetMixins) {
  @Prop({ default: false, required: true }) state!: boolean;
  @Prop({ default: false }) dialogLoading!: boolean;
  @Prop({ default: false }) loading!: boolean; // button loading
  @Prop({ default: false }) contacts!: Array<IContact>;
  @Prop({ default: () => [] }) assignedContacts!: number[];

  @groupsModule.Getter('getGroupContactsPagination') paginate!: Pick<
    IPaginate,
    'page' | 'total' | 'itemsPerPage' | 'pages'
  > & { limit: number };

  selected: IContact[] | number[] = [];
  headers: Array<{ text: string; value: string; align?: string }> = [
    {
      text: 'Name',
      value: 'name',
    },
    {
      text: 'Phone Number',
      value: 'phone',
    },
  ];

  total = 0;
  search = '';

  options: IPaginate = {
    page: 1,
    total: 0,
    pages: 1,
    itemsPerPage: 30,
  };

  @Watch('search')
  onSearchTextChanged(term: string): void {
    this.handleOnSearchTermChange(term);
  }
  handleOnSearchTermChange = debounce(this.searchText, 1000);
  searchText(text: string): void {
    const id = this.$route.query?.id as string;
    if (id) {
      this.$store.dispatch('group/listGroupContacts', {
        searchTerm: text,
        page: 1,
        id,
        isPaginated: true,
        limit: 30,
      });
    }
  }

  loadMore(): void {
    const id = this.$route.query?.id as string;
    if (id) {
      let payload = {
        searchTerm: this.search,
        ...this.options,
        id,
        isPaginated: true,
      };
      this.$store.dispatch('group/loadMore', payload);
    }
  }

  @Watch('paginate')
  onPaginationChange(payload: IPaginate): void {
    this.options = { ...payload };
    this.selected = [];
  }

  @Emit('removeContacts')
  removeContactsToGroup(): IContact[] | number[] {
    return this.selected;
  }

  @Emit('actions')
  close(): PayloadState {
    this.search = '';
    return {
      idx: 'list',
      state: false,
    };
  }
}
